import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Button, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { FilterToolbar } from '../FilterToolbar';
import { IFilterParams, IParamsList } from '../../interfaces';
import { useIsLocalFilter, usePagesStoreCurrentPage, useUiViewInfo } from '../../hooks';
import { setUiIsLocalFilter, setUiUrlStorePage } from '../../middleware';
import { ITrPage, tB, tP } from '../../translate';
import { Catcher } from '../Catcher';
import Styles from '../styles/m_itemCardStyles.less';

type ICustomFilterExport = {
    filterParams?: IFilterParams;
    exportButtons?: React.ReactNode;
};

export const CustomFilterExport: React.FC<ICustomFilterExport> = observer(
    ({ filterParams, exportButtons }: ICustomFilterExport) => {
        const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
        const [viewParams, setViewParams] = useState<IParamsList>({});
        const { title } = usePagesStoreCurrentPage();
        const titleShow = title ? tP(title as ITrPage) : '';
        const isLocalFilter = useIsLocalFilter();
        const storeParams = useUiViewInfo();
        const exportFilterParams = { ...filterParams };
        delete exportFilterParams?.pageSize;

        const openModal = () => {
            setUiIsLocalFilter(true);
            setIsModalVisible(true);
        };
        const closeModal = () => {
            setUiUrlStorePage(viewParams);
            setUiIsLocalFilter(false);
            setIsModalVisible(false);
        };
        const onReload = () => {
            setUiUrlStorePage(viewParams);
        };

        const onFilterChange = () => {
            // console.log(Date.now(), `--()-  ->`);
        };

        useEffect(() => {
            if (!isLocalFilter) {
                setViewParams(storeParams);
            }
        }, [isLocalFilter, JSON.stringify(storeParams)]);

        return (
            <Catcher>
                <Button onClick={openModal}>{tB('Export')}</Button>
                <Modal
                    title={`${titleShow} (${tB('Export')})`}
                    open={isModalVisible}
                    wrapClassName={'modal'}
                    onCancel={closeModal}
                    footer={
                        <div className={Styles.modalToolBar}>
                            <Button key="reload" id="reload" icon={<ReloadOutlined />} onClick={onReload}>
                                {tB('Reload')}
                            </Button>
                            <div className={Styles.space} />
                            {exportButtons ? exportButtons : null}
                            <Button key="back" id="back" type="primary" onClick={closeModal}>
                                {tB('Cancel')}
                            </Button>
                        </div>
                    }
                    width={1200}
                >
                    <FilterToolbar filterParams={exportFilterParams} onChange={onFilterChange} />
                </Modal>
            </Catcher>
        );
    },
);
